import { render, staticRenderFns } from "./MonthlyProfessionalWorkplaceReport.vue?vue&type=template&id=d45b5fe0&"
import script from "./MonthlyProfessionalWorkplaceReport.vue?vue&type=script&lang=js&"
export * from "./MonthlyProfessionalWorkplaceReport.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyProfessionalWorkplaceReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports